<template>
  <b-row>
    <b-col cols="12">
      <p>
        <span>Download der Suchergebnisse</span>
        <download-excel
          class="btn btn-outline-primary btn-sm d-inline"
          :data="getCurrentResultJSON()"
          :fields="getExportFields()"
          :meta="getExportMeta()"
        >xls</download-excel>
        <download-excel
          type="csv"
          class="btn btn-outline-primary btn-sm d-inline"
          :data="getCurrentResultJSON()"
          :fields="getExportFields()"
          :meta="getExportMeta()"
        >csv</download-excel>
        <span>Download des kompletten Medienarchives</span>
        <download-excel
          class="btn btn-outline-primary btn-sm d-inline"
          :data="getCompleteResultJSON()"
          :fields="getExportFields()"
          :meta="getExportMeta()"
        >xls</download-excel>
        <download-excel
          type="csv"
          class="btn btn-outline-primary btn-sm d-inline"
          :data="getCompleteResultJSON()"
          :fields="getExportFields()"
          :meta="getExportMeta()"
        >csv</download-excel>
      </p>
    </b-col>

    <b-col cols="12">
      <p>Artikel {{ offsetFrom + 1 }}-{{ offsetTo }} von {{ totalRows }}</p>
    </b-col>

    <div class="col-12" v-for="(item, index) in items" :key="index">
      <SearchResultSingle :item="item"></SearchResultSingle>
    </div>

    <b-pagination
      align="center"
      :total-rows="totalRows"
      :per-page="limit"
      v-model="currentPage"
      @input="paginatedData">
    </b-pagination>
  </b-row>
</template>

<script>
  import JsonExcel from 'vue-json-excel'
  import Mapping from '@/mapping'
  import SearchResultSingle from './SearchResultSingle.vue'

  export default {
    name: 'SearchResult',
    data() {
      return {
        totalRows: 0,
        currentPage: 1,
        offsetFrom: 0,
        offsetTo: 0,
        limit: 25,
        items: []
      }
    },
    components: {
      SearchResultSingle,
      'downloadExcel': JsonExcel
    },
    computed: {
      paginatedData(state) {
        this.getDataSet(this.currentPage)
      }
    },
    methods: {
      getExportFields() {
        return Mapping.export.fields
      },
      getExportMeta() {
        return Mapping.export.meta
      },
      getCurrentResultJSON() {
        let search = this.$store.getters.getSearchResult
        let res = []

        for (let i = 0; i < search.length; i++) {
          res.push(search[i])
        }

        return res
      },
      getCompleteResultJSON() {
        let items = this.$store.getters.getAllItems
        let res = []

        for (let i = 0; i < items.length; i++) {
          res.push(items[i])
        }

        return res
      },
      getDataSet(curPage) {
        let res = this.$store.getters.getSearchResult
        this.offsetFrom = (curPage - 1) * this.limit
        this.offsetTo = this.offsetFrom + this.limit

        let listLength = res.length
        if (this.offsetFrom > listLength) {
          this.items = []
          return
        }

        if (this.offsetTo > listLength) {
          this.offsetTo = listLength
        }

        this.totalRows = listLength
        this.items = res.slice(this.offsetFrom, this.offsetTo)
      },
      paginationChange(page) {
        this.getDataSet(page, this.limit)
      }
    },
    mounted() {
      this.getDataSet(1, this.limit)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SearchResult.vue